import React, { useContext, useState } from 'react';
import {
  string, arrayOf, shape, func, bool
} from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Accordion } from '@thd-olt-component-react/accordion';
import { ProductPod } from '@thd-olt-component-react/product-pod';
import { extend } from '@thd-nucleus/data-sources';
import { Col, Row } from '@thd-olt-component-react/grid';
import { Card } from '@thd-olt-component-react/card';
import { getTypeTabTitle } from '../Helper';
import { SingleIRG } from './SingleIRG';

export const MultipleAccordionIRG = ({ tabs, onClickCategory, onClickNext, showMobileCardTabs }) => {

  const {
    channel,
  } = useContext(ExperienceContext);

  const [accordionState, setAccordionState] = useState([true, true, true]);

  const buildTitle = (tab) => {
    return (
      <>
        {
          getTypeTabTitle(tab.name, tab?.brandName, true)
        } <span className="item-related-groups__title-number">({tab?.itemIds?.length})</span>
      </>
    );
  };

  if (tabs.length === 0) {
    return null;
  }
  if (tabs.length === 1) {
    return <SingleIRG tab={tabs[0]} />;
  }

  const onAccordionItemChange = ({ open, index }) => {
    setAccordionState((previousState) => {
      const ret = [...previousState];
      ret[index] = open;
      return ret;
    });
  };

  const buildAccordionDesktop = () => {
    return (
      <Accordion>
        {tabs.filter((tab) => tab?.itemIds?.length)
          .map((tab, index) => {
            return (
              <Accordion.Item
                key={`${tab.name}-${index}`}
                heading
                title={buildTitle(tab)}
                type="checkbox"
                name={tab.name}
                open
                onChange={({ open }) => onAccordionItemChange({
                  open,
                  index
                })}
              >
                {accordionState[index] && (
                  /* eslint-disable-next-line */
                  <SingleIRG
                    tab={tab}
                    onClickNext={onClickNext}
                    onClickCategory={onClickCategory}
                  />
                )}
              </Accordion.Item>
            );
          })}
      </Accordion>
    );
  };

  const buildMobileCardSecondaryImage = (src) => {
    return (
      <Col fallback="6" nopadding>
        <div className="item-related-groups__mobile-card__image">
          <img src={src} alt="secondary product" />
        </div>
      </Col>
    );
  };

  const buildMobileIRGCard = () => {
    return tabs.filter((tab) => tab?.mobileCardImageUrls?.length)
      .map((tab, index) => {
        const shouldRenderMoreItemsRow = tab?.mobileCardImageUrls?.length > 3;
        return (
          <Card noHide key={`${tab.name}-${index}`} className="item-related-groups__mobile-card">
            <Card.Content title={getTypeTabTitle(tab.name, tab?.brandName, true)} maxHeight="none">
              <Row>
                <Col className="item-related-groups__mobile-card__col__1" fallback="6">
                  <img src={tab.mobileCardImageUrls[0]} alt="main product" />
                </Col>
                <Col className="item-related-groups__mobile-card__col__2" fallback="6" nopadding>
                  <Row>
                    {buildMobileCardSecondaryImage(tab.mobileCardImageUrls[1])}
                    {tab?.mobileCardImageUrls?.length > 2 && buildMobileCardSecondaryImage(tab.mobileCardImageUrls[2])}
                  </Row>
                  {shouldRenderMoreItemsRow && (
                    <Row>
                      {buildMobileCardSecondaryImage(tab.mobileCardImageUrls[3])}
                      <Col fallback="6" nopadding>
                        <div className="item-related-groups__mobile-card__more-items__container">
                          <span>+{tab?.itemIds?.length - 4} More Items</span>
                        </div>
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>
              <Card.Content.Overlay>
                <SingleIRG
                  tab={tab}
                  onClickNext={onClickNext}
                  onClickCategory={onClickCategory}
                  accordion
                  showMobileCardTabs={showMobileCardTabs}
                />
              </Card.Content.Overlay>
            </Card.Content>
          </Card>
        );
      });
  };

  return channel === 'mobile' ? buildMobileIRGCard() : buildAccordionDesktop();
};

MultipleAccordionIRG.propTypes = {
  tabs: arrayOf(shape({
    name: string
  })).isRequired,
  onClickCategory: func,
  onClickNext: func,
  showMobileCardTabs: bool
};

MultipleAccordionIRG.dataModel = extend({}, ProductPod);

const NOOP = () => {
};

MultipleAccordionIRG.defaultProps = {
  onClickCategory: NOOP,
  onClickNext: NOOP,
  showMobileCardTabs: false
};
